// import './search.scss';
import './img/Search.svg';

/* eslint-disable */

var hover_block = $('.hover_div');
var form_block =  $('.formasearch-block');
var speed = 300;

function showLine(){
    form_block.find('.wrap_input').addClass('show_line');
    form_block.find('.wrap_input input').focus();
}

function hideLine(){
    form_block.find('.wrap_input').removeClass('show_line');
    form_block.find('.wrap_input input').blur();
}

function showBtn(){
    form_block.find('.search_sbn_hov').fadeIn();
}

function hideBtn(){
    form_block.find('.search_sbn_hov').fadeOut();
}

/* показываем форму при клике на кнопку */
$('.search_btn').on('click', function(e){
    e.preventDefault();
    form_block.fadeIn(speed);
    hover_block.fadeIn(speed, showLine);

});

/* показываем кнопку если введено больше 3 символов */
$('.wrap_input input').keypress(function(){
    var count_litter = $(this).val();
    if(count_litter.length >= 3 ){
        showBtn();
    }else{
        hideBtn();
    }
});

/* скрываем кнопку если введено меньше 3 символов */
$('.wrap_input input').keydown(function(){
    var count_litter = $(this).val();
    if(count_litter.length <= 3 ){
        hideBtn();
    }
});

/* скрываем форму при клике на свободную область */
hover_block.on('click', function(){
    if($(this).is(':visible')){
        form_block.fadeOut(100);
        $(this).fadeOut(speed, hideLine());
    }
});



// WEBPACK FOOTER //
// ./resources/views/partials/index/search/search.js